import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth")({
  component: AuthLayout,
  beforeLoad: ({ context }) => {
    if (context.auth.user) {
      throw redirect({
        to: "/dashboard",
      })
    }
  },
})

function AuthLayout() {
  return (
    <div className="flex h-dvh">
      <div className="relative hidden flex-1 items-center justify-center overflow-hidden bg-gradient-to-br from-[#2563a8] via-[#1C4B79] to-[#0f2d4a] md:flex">
        {/* Decorative elements */}
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMC41IiBvcGFjaXR5PSIwLjEiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JpZCkiLz48L3N2Zz4=')] opacity-20"></div>
        
        {/* Content */}
        <div className="relative z-10 flex flex-col items-center gap-14 px-8">
          {/* Logo */}
          <div className="flex items-center justify-center">
            <img 
              src="/dark-logo.png"
              alt="ONEai Health" 
              className="h-36 w-auto drop-shadow-2xl"
            />
          </div>
          
          <p className="text-center text-lg font-medium drop-shadow" style={{ color: "#04CBB3" }}>
            Catch drifts early. Prevent avoidable escalations.
          </p>
        </div>
      </div>
      <div className="flex flex-1 items-center justify-center bg-gray-50 p-6">
        <Outlet />
      </div>
    </div>
  )
}
